import { Component, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";

@Component({
    selector: 'medpt-root-css-variables',
    templateUrl: './root-css-variables.component.html',
    styleUrls: ['./root-css-variables.component.scss'],
    standalone: false
})
export class RootCssVariablesComponent implements OnInit {

  cdnEndPoint = environment.cdnEndPoint;

  constructor() { }

  ngOnInit(): void {

    const css = this.getCssRoot();
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
  }

  private getCssRoot() {
    return `
          :root {
          --cdn-image-arrow-down: '${this.cdnEndPoint}/triport/icons/community/arrow down.svg';
          --cdn-image-arrow-down-url: url('${this.cdnEndPoint}/triport/icons/community/arrow down.svg');
          --cdn-image-arrow-down-grey: '${this.cdnEndPoint}/triport/icons/community/arrow down-1.svg';
          --cdn-image-arrow-down-grey-url: url('${this.cdnEndPoint}/triport/icons/community/arrow down-1.svg');
          --cdn-image-arrow-down-white: '${this.cdnEndPoint}/triport/icons/community/arrow-down-white.svg';
          --cdn-image-arrow-down-white-url: url('${this.cdnEndPoint}/triport/icons/community/arrow-down-white.svg');
          --cdn-image-arrow-left: '${this.cdnEndPoint}/triport/icons/community/arrow.svg';
          --cdn-image-arrow-left-url: url('${this.cdnEndPoint}/triport/icons/community/arrow.svg');
          --cdn-image-arrow-right: '${this.cdnEndPoint}/triport/icons/community/arrow-2.svg';
          --cdn-image-arrow-right-url: url('${this.cdnEndPoint}/triport/icons/community/arrow-2.svg');
          --cdn-image-arrow-right-3: '${this.cdnEndPoint}/triport/icons/community/arrow-3.svg';
          --cdn-image-arrow-right-3-url: url('${this.cdnEndPoint}/triport/icons/community/arrow-3.svg');
          --cdn-image-globe: '${this.cdnEndPoint}/triport/icons/Globe.svg';
          --cdn-image-globe-url: url('${this.cdnEndPoint}/triport/icons/Globe.svg');
          --cdn-image-calendar: '${this.cdnEndPoint}/triport/icons/community/calendar.svg';
          --cdn-image-calendar-url: url('${this.cdnEndPoint}/triport/icons/community/calendar.svg');
          --cdn-image-search: '${this.cdnEndPoint}/triport/icons/community/search.svg';
          --cdn-image-search-url: url('${this.cdnEndPoint}/triport/icons/community/search.svg');
          --cdn-image-close-url: url('${this.cdnEndPoint}/triport/icons/submenu/close.svg');
          --cdn-image-success-url: url('${this.cdnEndPoint}/triport/icons/submenu/success.svg');
          --cdn-image-success-white-url: url('${this.cdnEndPoint}/triport/icons/submenu/success-white.svg');
          --cdn-image-warning-url: url('${this.cdnEndPoint}/triport/icons/submenu/warning.svg');
          --cdn-image-warning-white-url: url('${this.cdnEndPoint}/triport/icons/submenu/warning-white.svg');
          --cdn-image-info-url: url('${this.cdnEndPoint}/triport/icons/submenu/info.svg');
          --cdn-image-info-white-url: url('${this.cdnEndPoint}/triport/icons/submenu/info-white.svg');
          --cdn-image-error-url: url('${this.cdnEndPoint}/triport/icons/submenu/error.svg');
          --cdn-image-error-white-url: url('${this.cdnEndPoint}/triport/icons/submenu/error-white.svg');
          --cdn-image-inprogress-url: url('${this.cdnEndPoint}/triport/icons/submenu/inprogress.svg');
          --cdn-image-inprogress-white-url: url('${this.cdnEndPoint}/triport/icons/submenu/inprogress-white.svg');
          --cdn-image-info-plain-url: url('${this.cdnEndPoint}/triport/icons/info.svg');
          --cdn-image-info-active-url: url('${this.cdnEndPoint}/triport/icons/info_active.svg');
          /*Top menu images*/
          --topmenu-admin-default-url: url('${this.cdnEndPoint}/triport/icons/topmenu/admin.svg');
          --topmenu-notification-default-url: url('${this.cdnEndPoint}/triport/icons/topmenu/notification.svg');
          --topmenu-help-default-url: url('${this.cdnEndPoint}/triport/icons/topmenu/help.svg');
          --topmenu-user-default-url: url('${this.cdnEndPoint}/triport/icons/topmenu/user.svg');
          --appmenu-header-icon: url('${this.cdnEndPoint}/triport/icons/leftmenu/apps.svg');
          --explore-menu-arrow-icon: url('${this.cdnEndPoint}/triport/icons/leftmenu/arrow.svg');

          --topmenu-admin-white-url: url('${this.cdnEndPoint}/triport/icons/topmenu/admin-white.svg');
          --topmenu-notification-white-url: url('${this.cdnEndPoint}/triport/icons/topmenu/notification-white.svg');
          --topmenu-help-white-url: url('${this.cdnEndPoint}/triport/icons/topmenu/help-white.svg');
          --topmenu-user-white-url: url('${this.cdnEndPoint}/triport/icons/topmenu/user-white.svg');

          --submenu-password-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/password.svg');
          --submenu-password-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/password-1.svg');
          
          --submenu-passkey-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/passkey.svg');
          --submenu-passkey-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/passkey-1.svg');

          --submenu-userlogin-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/user login-1.svg');
          --submenu-userlogin-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/user login.svg');

          --submenu-logout-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/logout.svg');
          --submenu-logout-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/logout-1.svg');

          --submenu-help-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/help.svg');
          --submenu-help-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/help-1.svg');

          --submenu-contact-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/contact-1.svg');
          --submenu-contact-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/contact.svg');

          --submenu-tools-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/tools.svg');
          --submenu-tools-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/tools-1.svg');

          --submenu-reports-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/reports-1.svg');
          --submenu-reports-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/reports.svg');

          --submenu-analytics-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/analytics.svg');
          --submenu-analytics-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/analytics-1.svg');

          --submenu-globaltools-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/tools-2.svg');
          --submenu-globaltools-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/tools-3.svg');

          --submenu-portaltools-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/portal tools.svg');
          --submenu-portaltools-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/portal tools-1.svg');

          --submenu-enterpriseportaltools-default-url: url('${this.cdnEndPoint}/triport/icons/submenu/enterpriseportaltools.svg');
          --submenu-enterpriseportaltools-blue-url: url('${this.cdnEndPoint}/triport/icons/submenu/enterpriseportaltools-1.svg');

          --leftmenu-apps-default-url: url('${this.cdnEndPoint}/triport/icons/leftmenu/apps.svg');
          --leftmenu-arrow-default-url: url('${this.cdnEndPoint}/triport/icons/leftmenu/arrow.svg');


          /*Reports*/
          --filter-blue-fill-check-icon: url('${this.cdnEndPoint}/triport/icons/filter_blue_fill_check.svg');
          --filter-blue-fill-icon: url('${this.cdnEndPoint}/triport/icons/filter_blue_fill.svg');
          --filter-blue-checkbox-icon: url('${this.cdnEndPoint}/triport/icons/filter_blue_checkbox.svg');
          --filter-white-icon: url('${this.cdnEndPoint}/triport/icons/filter_white.svg');
          --filter-blue-icon: url('${this.cdnEndPoint}/triport/icons/filter_blue.svg');
          --filter-icon: url('${this.cdnEndPoint}/triport/icons/filter.svg');
          --userreg-icon: url('${this.cdnEndPoint}/triport/icons/user reg.svg');
          --reports-icon: url('${this.cdnEndPoint}/triport/icons/reports.svg');
          --download-icon: url('${this.cdnEndPoint}/triport/icons/download.svg');
          --download-white-icon: url('${this.cdnEndPoint}/triport/icons/download_white.svg');
          --email-icon: url('${this.cdnEndPoint}/triport/icons/email.svg');
          --email-white-icon: url('${this.cdnEndPoint}/triport/icons/email_white.svg');
          --globemap-white-icon: url('${this.cdnEndPoint}/triport/icons/Globemap-white.svg');
          --globemap-blue-icon: url('${this.cdnEndPoint}/triport/icons/Globemap-blue.svg');

          /* Dashboard*/
          --study-blue-icon: url('${this.cdnEndPoint}/triport/icons/study blue.svg');
          --maintenance-blue-icon: url('${this.cdnEndPoint}/triport/icons/maintenance blue.svg');
          --star-orange-hover-icon: url('${this.cdnEndPoint}/triport/icons/star orange hover.svg');
          --star-hover-icon: url('${this.cdnEndPoint}/triport/icons/star hover.svg');
        }
      `;
  }

}
